import React, { useEffect, useState } from 'react'
import { useLocation, Link, useHistory } from 'react-router-dom'
import Styles from './confirmar-voto.module.scss'
import { Button, Card, Form, Image, Input, message, Modal, Popconfirm } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import MaskedInput from 'react-input-mask'
import DesenhoService from 'src/services/Desenho-Service/desenho-service';
import { VotoPopularModel } from 'src/features/Models/votoPopular-model';
import { EyeOutlined, FilePdfOutlined } from '@ant-design/icons';
import VotoPopularService from 'src/services/VotoPopular-Service/votoPopular-service';
import { Document, Page, pdfjs } from 'react-pdf';
import Spinner from 'src/public/components/Spinner/spinner-component';

const ConfirmarVoto: React.FC<any> = () => {
    let location = useLocation();
    const [html, setHtml] = useState<any>(<></>)
    const [loading, setLoading] = useState<boolean>(false)
    const [ocultar, setOcultar] = useState<boolean>(false)
    const [form] = Form.useForm();
    const [votoPopular, setVotoPopular] = useState<any>()
    const [desenho, setDesenho] = useState<any>()
    const [base64, setBase64] = useState<any>()
    const [modalDesenho, setModalDesenho] = useState<boolean>(false)
    const [numPages, setNumPages] = useState()
    const { Meta } = Card;
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
    let history = useHistory();

    useEffect(() => {
        setLoading(true)
        var infoVotoCriptografado = atob(location.pathname.substring(16))
        var res = infoVotoCriptografado.split('/')
        var voto = {
            email: FormataGmail(res[0]),
            desenhoId: parseInt(res[1]),
        }
        setVotoPopular(voto)
        DesenhoService.getByDesenhoID(voto.desenhoId).then((response: any) => {
            if (response.data !== null) {
                setDesenho(response.data)
            }
        })
            .catch((error) => {
                if (error.response != undefined) {
                    error.response.data.error.map((a: any) => {
                        message.error(a)
                    })
                }
                else {
                    message.error('Erro na conexão com servidor')
                }
            }).finally(() => {
                DesenhoService.downloadDesenhoBase64ById(voto.desenhoId).then((response: any) => {
                    setBase64(response.result)
                })
                    .catch((error) => {
                        if (error.response != undefined) {
                            error.response.data.error.map((a: any) => {
                                message.error(a)
                            })
                        }
                        else {
                            message.error('Erro na conexão com servidor')
                        }
                    }).finally(() => {
                        setLoading(false)
                    })
            })
    }, []);

    const confirmarVoto = (values: any) => {
        setLoading(true)
        VotoPopularService.postConfirmarVoto(votoPopular).then((response: any) => {
            message.success({
                content: 'Voto confirmado com sucesso!',
                style: {
                    fontSize: '18px'
                }
            })
        })
            .catch((error) => {
                if (error.response != undefined) {
                    error.response.data.error.map((a: any) => {
                        message.error(a)
                    })
                }
                else {
                    message.error('Erro na conexão com servidor')
                }
            }).finally(() => {
                setLoading(false)
                history.push('/votacao-popular')
            })


    }

    const onDocumentLoadSuccess = (n: any) => {
        setNumPages(n._pdfInfo.numPages)
    }

    const FormataGmail = (email: string) => {
        let v = email.split("@");
        if (v[1].toUpperCase().includes("GMAIL")) {
            let email = v[0].replaceAll(".", "");
            return `${email}@gmail.com`
        } else {
            return email;
        }
    }

    return (
        <>
            <Spinner loading={loading} />
            <div className={Styles.fundo}>
                <div className={Styles.Titulo}>
                    Confirmação de Voto
                </div>
                <div className={Styles.Buttons}>
                    <Card
                        loading={loading}
                        hoverable
                        className={desenho?.contentType == 'application/pdf' ? Styles.CardPdf : Styles.Card}
                        cover={desenho?.contentType == 'application/pdf' ?
                            <>
                                <Document
                                    file={`data:application/pdf;base64,${base64}`}
                                    options={{ workerSrc: './pdf.worker.js' }}
                                    onLoadSuccess={onDocumentLoadSuccess}

                                >
                                    <Page className={Styles.pdf} pageNumber={1} height={600} />
                                </Document>
                            </>

                            :
                            <Image
                                preview={{ mask: <><EyeOutlined />&nbsp;Visualizar</> }}
                                className={Styles.Preview}
                                src={`data:${desenho?.contentType};base64,${base64}`}
                            />
                        }
                    >
                        <Meta className={Styles.CardBody} title={<>
                            <div className={Styles.InfoDesenho}>
                                <p><b>Modalidade:</b> {desenho?.modalidadeDesenho?.descricao}</p>
                                <p><b>Categoria:</b> {desenho?.inscricao?.categoria == null ? '' : desenho?.inscricao?.categoria == "ESTUDANTE" ? "Estudante" : "Sociedade Civil"}</p>
                            </div>
                            <Popconfirm placement="top" title="Você tem certeza que deseja votar no desenho acima?" onConfirm={confirmarVoto} okText="Sim" cancelText="Não">
                                <Button htmlType='button' className={Styles.ButtonVotar}>
                                    Confirmar Voto
                                </Button>
                            </Popconfirm>

                        </>} />
                    </Card>
                </div>
            </div>
        </>
    )
}
export default ConfirmarVoto